var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M972.4 137s.2-.1 0 0L696.9 24.6c-1.8-.4-3.4-1.2-5.3-1.2-9.4 0-17.3 5.5-21.1 13.3L665 46.9c-31.1 57.3-91.9 91.5-162.7 91.5-70.8 0-131.6-34.2-162.7-91.5l-6.1-11.2c-3.9-7.2-11.3-12.1-20.1-12.1-2.2 0-4.2.8-6.1 1.3L27.6 133.6s.3.1.1.1C17.3 138.6 10 149.2 10 161.5v.1l1.3 239.6c.9 16 14.1 28.9 30.2 28.9 4.2 0 8.3-.9 12-2.5.1 0 0 .1.1.1L205.3 371v574.3c0 16.9 13.7 30.6 30.6 30.6l533.4.7c16.9 0 30.6-13.7 30.6-30.6V366l147.9 61c.1 0 0-.1.1-.1 3.6 1.6 7.7 2.5 12 2.5 16 0 28.6-12.4 30.1-28v-238c-.5-11.7-7.4-21.8-17.6-26.4zm-11.7 258.2-156.5-62.6c-2.5-.8-5.1-1.4-7.9-1.4-14.3 0-25.9 11.6-26.2 25.8v589.7H232.9V353.4c-2-12.5-12.4-22.1-25.4-22.1-2.6 0-5.1.7-7.6 1.3L46.3 395.3V161.1l257.3-96.7c48.6 66.7 110.8 104.8 200 104.8s143.3-38.1 191.9-104.8l265.2 96.7v234.1z",
    fill: "#0B0C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/shirt.497c8a054fe29f89dbde89435e8e509e.svg";
export { ForwardRef as ReactComponent };